<style scoped lang="less">
	.dates {
		li {
			display: flex;
			align-items: center;
			height: 2rem;
			// border: 1px solid;
			box-sizing: border-box;
			padding: 20px 10px;
			color: #333;
			background-color: #fff;
			border-radius: 5px;
			justify-content: space-between;
			letter-spacing: 1px;
			margin-bottom: 20px;

			span {
				color: #000;
			}
		}
	}

	.dateselx {
		background-color: #55ACEE !important;
		color: #fff !important;

		span {
			color: #fff !important;
		}
	}

	.titles {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		color: #fff;
		background-color: #55ACEE;

		p {
			font-size: 1.2rem;
		}

		button {
			padding: 8px 10px;
			border-radius: 10px;
			color: #fff;
			background-color: #F2125E;
			margin: 0 1rem;

			span {
				font-weight: 900;
			}
		}

		p {
			display: flex;
			align-items: center;
			margin: 0 10px;

			i {
				margin-right: 10px;
				font-size: 1.4rem;
			}
		}

	}

	/deep/ .el-collapse-item:first-child {
		margin-top: 0;
	}

	/deep/ .el-collapse-item {
		margin: 1rem 0;
	}

	/deep/ .el-collapse-item__header {
		background-color: #55ACEE;
		height: 100%;

		i {
			color: #fff;
		}
	}

	.content {
		padding: 10px;

		.conha {
			margin-left: 20px;
			margin-top: 1rem;
			border-top: 1px solid #aaa;
			box-sizing: border-box;
			padding: 1rem;
		}

		.ipthd {
			display: flex;
			align-items: center;
			margin: 2% 0;

			input {
				border-radius: 20px;
			}

			button {
				width: 10%;
			}
		}
	}

	p {
		overflow: initial;
		white-space: initial;
		text-overflow: initial;
	}

	/* 设置持续时间和动画函数 */
	.v-enter-active,
	.v-leave-active {
		transition: all .8s ease;
	}

	.v-enter,
	.v-leave-to {
		transform: translateY(100px);
		opacity: 0;
	}

	.btnmytack {
		margin: 1rem 0;
		// width: 10%;
		color: #fff;
		padding: 0.8rem;
		border-radius: 10px;
		font-size: 0.8vw;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__header {
		text-align: center;
		padding: 14px 19px 10px;
		background: #05A34A;
		color: #fff !important;
		font-size: 1.2rem;

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
			font-size: 1.4rem;

		}

		.el-dialog__title {
			color: #fff !important;

		}

		.dialog-header-title {
			span {
				margin-left: 0.6rem;
			}
		}
	}

	.titleas {
		display: flex;
		align-items: left;
		justify-content: center;
		flex-direction: column;
		margin: 0.8rem;

		p {
			font-size: 1rem;
		}
	}
</style>
<template>
	<div>
		<titles titlename="用户反馈" titlecontent="这里可以看到用户反馈一些信息" :mbx="paths"></titles>
		<button @click="dialogVisible = true" class="btnmytack" style="background-color:#42B857 ;"
			@click.stop="myspickpt()">
			<span class="el-icon-phone-outline">
			</span>
			我要提问
		</button>
		<el-dialog title="我要反馈" :column="1" :visible.sync="dialogVisible" width="40%">
			<el-descriptions direction="vertical">
				<el-descriptions-item label="标题" :span="3">
					<el-input v-model="texttitle" type="text" placeholder="请输入标题">
					</el-input>
				</el-descriptions-item>
				<el-descriptions-item label="我的提问" :span="3">
					<el-input v-model="textarea" type="textarea" :rows="6" placeholder="请输入提问内容">
					</el-input>
				</el-descriptions-item>
			</el-descriptions>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogdeteok()">确 定</el-button>
			</span>
		</el-dialog>
		<div class="prombleom">
			<el-row :gutter="10">
				<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
					<ul class="dates">
						<li @click="dateselxa" :class="{'dateselx':dateselx==1}">
							<p>已解决问题</p>
							<span class="el-icon-arrow-right"></span>
						</li>
					</ul>

					<ul class="dates">
						<li @click="changedateselx" :class="{'dateselx':dateselx==0}">
							<p>待解答问题</p>
							<span class="el-icon-arrow-right"></span>
						</li>
					</ul>
				</el-col>
				<el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
					<div class="headerq" v-if="dateselx==1 && tatck.length!=0">
						<el-collapse v-model="activeName" accordion>
							<el-collapse-item :name="index+1" v-for="(item,index) in tatck" :key="index">
								<template slot="title">
									<div class="titles">
										<p style="margin-left: 1rem;">
											标题：{{item.fe_questionTitle}}
										</p>


										<p>
											提问人：{{item.quizzerName}}
										</p>
										<!-- <button @click.stop="titlexsipt()">
											<span class="el-icon-chat-dot-square">
											</span>
											我来解答
										</button> -->

									</div>
								</template>
								<div class="content">
									<div class="titleas">
										<p>
											提问人：{{item.quizzerName}}
										</p>
										<!-- style="margin-left: 1rem;" -->
										<p>
											所属学院：{{item.SchoolName}}
										</p>
										<p>
											所属班级：{{item.ClaName}}
										</p>
									</div>

									<div style="color: #000;font-size: 1.4rem;margin: 1rem 0;">
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.fe_questionContent}}
									</div>
									<span
										style="margin-left: 10px;color: #aaa;font-size: 0.8rem;">{{item.fe_createTime}}</span>


									<ul class="conha">
										<li>
											<p style="font-size: 1rem;">{{item.replierName}}<span
													style="margin-left: 1rem;color: #aaa;">
													{{item.fe_replyTime}}
												</span></p>
											<p style="margin: 1rem;font-size: 1.2rem;color: #000;">
												{{item.fe_responseConten}}</p>
										</li>
									</ul>

								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
					
					<div class="headerq" v-if="dateselx==0 && tatck.length!=0">
						<el-collapse v-model="activeName" accordion>
							<el-collapse-item :name="index+1" v-for="(item,index) in tatck" :key="index">
								<template slot="title">
									<div class="titles">

										<p style="margin-left: 1rem;">
											标题：{{item.fe_questionTitle}}
										</p>


										<p>
											提问人：{{item.quizzerName}}
										</p>
										<!-- <button @click.stop="titlexsipt()">
											<span class="el-icon-chat-dot-square">
											</span>
											我来解答
										</button> -->
									</div>
								</template>
								<div class="content">
									<div class="titleas">
										<p>
											提问人：{{item.quizzerName}}
										</p>
										<!-- style="margin-left: 1rem;" -->
										<p>
											所属学院：{{item.SchoolName}}
										</p>
										<p>
											所属班级：{{item.ClaName}}
										</p>
									</div>
									<div style="color: #000;font-size: 1.4rem;margin: 1rem 0;">
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.fe_questionContent}}
									</div>
									
									<span
										style="margin-left: 10px;color: #aaa;font-size: 0.8rem;">{{item.fe_createTime}}</span>
									<div class="ipthd" v-if="item.istotack == 1">
										<input type="text" class="form-control" id="exampleInputEmail1"
											aria-describedby="emailHelp" placeholder="请输入信息" v-model="fequconten">
										<button @click="ipthdfs(item)"
											style="color: #fff;height: 3vh; width: 10%;margin: 0 1%; font-size: 1rem; background-color: #42B857;border-radius: 20px;">发送</button>
									</div>
									<!-- <transition>
										<ul class="conha" v-show="titlexs">
											<li>
												<p>{{item.replierName}}</p>
												<p>{{item.fe_responseConten}}</p>
											</li>
										</ul>
									</transition> -->

								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				
					<div v-else-if="tatck.length == 0">
						<el-empty style="background-color: #fff;" description="没有数据"></el-empty>
					</div>
					
				
				</el-col>
			</el-row>

		</div>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import CollapseTransition from '@/components/CollapseTransition/CollapseTransition.vue'
	import {
		FeedBackInsertOrEdit,
		GetFeedBackListIsComplete
	} from "@/request/api/mange/mange.js"


	export default {
		data() {
			return {
				// 标题
				paths: [{
					path: "/system/systemsrrtting",
					name: "问题反馈"
				}],
				// 标题
				titlexs: true,
				dateselx: 1,
				activeName: 1,
				dialogVisible: false,
				texttitle: "",
				textarea: "",
				datesall: false,
				tatck: [],
				sxfeguid: "",
				feresponseConten: "",
				fequconten:"",
				powershowobj:{}
			}
		},
		created() {
			let powerlist = JSON.parse(window.sessionStorage.getItem("allbtnlist"))
			this.powershowobj.powershows = powerlist
			this.powershowobj.routers = this.$route.path
		},
		beforeMount() {
			this.gettatck()
		},
		methods: {
			ipthdfs(item) {
				this.sxfeguid = item.sx_fe_guid
				this.feresponseConten = this.fequconten
				this.texttitle = ""
				this.textarea = ""
				this.dialogdeteok(1)
				
			},
			gettatck() {
				GetFeedBackListIsComplete(this.dateselx).then(res => {
					// console.log(res)
					this.tatck = res.data.data
					this.tatck.forEach(item=>{
						item.istotack = 0
					})
					console.log("powershows===========>",this.powershowobj.powershows)
					
					this.powershowobj.powershows.forEach(item => {
						if (item.path == this.$route.path && this.dateselx == 0) {
							this.tatck.forEach(ite=>{
								ite.istotack = 1
							})
							console.log("有讨论可以看")
						}
					})
					
					// this.tatck = res.data.data
					console.log("this.tatck==============>",this.tatck)
				})
			},
			dialogdeteok(nua) {
				let dialogobj = {
					sx_fe_guid: this.sxfeguid,
					fe_questionTitle: this.texttitle,
					fe_questionContent: this.textarea,
					fe_responseConten: this.feresponseConten
				}

				FeedBackInsertOrEdit(dialogobj).then(res => {
					console.log(res)
					if (res.data.code == 1) {
						this.dialogVisible = false
						this.$message.success(res.data.msg);
						this.texttitle = ''
						this.textarea = ""
						this.fequconten = ""
					}
				})
				if(nua){
					this.gettatck()
				}
				
			},
			dateselxa() {
				this.dateselx = 1
				this.datesall = !this.datesall
				this.gettatck()
			},
			changedateselx() {
				this.dateselx = 0
				this.gettatck()
			},
			titlexsipt() {
				// console.log(1561)
				this.titlexs = !this.titlexs
			},
			myspickpt() {

			}

		},
		components: {
			titles,
			CollapseTransition
		}

	}
</script>
